module.exports = __webpack_public_path__ + "static/img/top-hi.33f3b73.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/top-hi.webp
// module id = 8KCZ
// module chunks = 1